module.exports = __webpack_public_path__ + "static/media/Shabnam.57960934.woff2";